export const environment = {
    production: false,
    etherpadHost: 'http://10.0.90.90:5555',
    lambdaApi: 'https://la361oi2dk.execute-api.us-east-1.amazonaws.com'
};
